const getMessages = state => state.lead.publisherChat.messages;
const getGroupMessages = state => state.lead.publisherChat.groupMessages;
const getMessageLoading = state => state.lead.publisherChat.loading;
const getStatus = state => state.lead.publisherChat.status;
const getLeadName = state => state.lead.publisherChat.leadName;
const getTabs = state => state.lead.publisherChat.tabs;
const getQuicklyResponse = state => state.lead.publisherChat.quicklyResponse;
const getSelectedTab = state => state.lead.publisherChat.tabs.find(t => t.isSelected);
const getUploadFiles = state => state.lead.publisherChat.filesToUpload;
const getUploadLoading = state => state.lead.publisherChat.fileLoading;
const getSnackBar = state => state.lead.publisherChat.snackBarAdjuntos;
const getShowmodal = state => state.lead.publisherChat.showModal;

export {
  getSelectedTab,
  getTabs,
  getQuicklyResponse,
  getMessages,
  getGroupMessages,
  getMessageLoading,
  getStatus,
  getLeadName,
  getUploadFiles,
  getUploadLoading,
  getSnackBar,
  getShowmodal
};
